import loadable from '@loadable/component'

export default [
  {
    path: '/joinGuide',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-JoinGuide-index" */ '~/pages/JoinGuide/pages/index'
        )
    ),
  },
  {
    path: '/joinGuide/detail/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-JoinGuide-detail" */ '~/pages/JoinGuide/pages/detail'
        )
    ),
  },
  {
    path: '/joinGuide/search',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-JoinGuide-search" */ '~/pages/JoinGuide/pages/search'
        )
    ),
  },
  {
    path: '/joinGuide/redirect',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-JoinGuide-redirect" */ '~/pages/JoinGuide/pages/redirect'
        )
    ),
  },
  {
    path: '/joinGuide/manage',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-JoinGuide-manage" */ '~/pages/JoinGuide/pages/manage'
        )
    ),
  },
  {
    path: '/joinGuide/record',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-JoinGuide-record" */ '~/pages/JoinGuide/pages/record'
        )
    ),
  },
  {
    path: '/joinGuide/edit',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-JoinGuide-edit" */ '~/pages/JoinGuide/pages/edit'
        )
    ),
  },
  {
    path: '/joinGuide/introduce',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-JoinGuide-introduce" */ '~/pages/JoinGuide/pages/introduce'
        )
    ),
  },
]
